<template>
  <a :href="`/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/`"
     class="no-default-style zt-hover cursor-pointer">
    <div v-if="variant === 'icon'" class="relative min-w-5 min-h-5">
      <img :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${filteringResult}-circle${index === 0 ? '-first' : ''}.svg`" />
    </div>
    <div v-else-if="!showPlusMinus" class="relative">
      <img :alt="filteringResult"
           v-if="index === 0"
           class="min-h-6 min-w-6"
           :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${filteringResult}-first.svg`" />
      <img :alt="filteringResult"
           v-else
           class="min-h-5 min-w-5"
           :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${filteringResult}.svg`" />
      <div v-if="statuses.extra.includes(match.status) && currentFilters[0] === '1x2'"
           class="absolute top-0 h-full w-1 bg-[#F1C411] left-0 rounded-l-zt"></div>
    </div>
    <div v-else>
      <img :alt="filteringResult"
           v-if="index === 0"
           class="min-h-6 min-w-6"
           :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${parsedFilteringResult === '-' ? 'minus' : 'plus'}-first.svg`" />
      <div v-else class="h-[20px] relative w-[20px] text-[11px] flex items-center justify-center
                             font-semibold rounded-zt xl:ml-0"
           :class="{ 'bg-[#32AB29]': parsedFilteringResult === '+',
                        'bg-[#CE2121]' : parsedFilteringResult === '-'}">
        {{ parsedFilteringResult }}
      </div>
    </div>

  </a>
</template>

<script>
import utils_mixin from "../../mixins/utils_mixin";
import football_mixin from "../../mixins/football_mixin";

export default {
  name: 'FootballStatsListItemIcon',
  mixins: [utils_mixin, football_mixin],
  props: {
    match: Object,
    teamId: {
      type: Number,
      default: 0
    },
    filteringResult: {
      type: String,
      default: '',
    },
    currentFilters: {
      type: Array,
      default: null,
    },
    displayingStat: {
      type: String,
      default: 'goals',
    },
    markWinner: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
    },
    index: Number
  },
  data() {
    return {
      statuses: {
        'live': ['1H', 'HT', '2H', 'ET', 'BT', 'P', 'LIVE'],
        'ended': ['FT', 'AET', 'PEN', 'CANC', 'ABD', 'AWD', 'WO'],
        'upcoming': ['TBD', 'NS', 'PST'],
        'extra': ['AET', 'PEN']
      },
      showVisitorGoalString: false,
      showLocalGoalString: false,
      justFinished: false,
    }
  },
  computed: {
    penaltyShootoutOccurred() {
      return this.match.localteam_penalty_shootout && this.match.visitorteam_penalty_shootout &&
          (this.match.localteam_penalty_shootout !== '0' || this.match.visitorteam_penalty_shootout !== '0');
    },
    parsedFilteringResult() {
      if (!this.showPlusMinus) {
        return this.filteringResult;
      }
      if (this.filteringResult === 'W') {
        return '+';
      } else {
        return '-';
      }
    },
    showPlusMinus() {
      if (!this.currentFilters) {
        return false;
      }
      if (this.currentFilters[0] === 'corners' && this.currentFilters[1] === 'result') {
        return false;
      }
      if (this.currentFilters[0] === 'cards' && this.currentFilters[2] === 'result') {
        return false;
      }
      return this.currentFilters[0] !== '1x2' && this.currentFilters[0] !== 'halfs';
    },
    localTeamStat() {
      if (this.matchStatus === 'CANC') {
        return '-';
      }
      if (this.displayingStat === 'corners') {
        return this.match.localteam_corners;
      }
      if (this.displayingStat === 'cards') {
        if (this.currentFilters[1] === 'yellowcards') {
          return this.match.localteam_yellowcards;
        } else {
          return this.match.localteam_red_cards
        }
      }
      if (this.displayingStat === 'firsthalf') {
        return this.match.localteam_ht_goals;
      }
      if (this.displayingStat === 'secondhalf') {
        return +this.match.localteam_goals - +this.match.localteam_ht_goals  - +this.match.localteam_et_goals;
      }
      if (this.displayingStat === 'penalty') {
        if (this.currentFilters[1] === 'for') {
          return +this.match.localteam_id === this.teamId ? this.match.localteam_penalties : this.match.visitorteam_penalties;
        } else  if (this.currentFilters[1] === 'against') {
          return +this.match.localteam_id === this.teamId ? this.match.visitorteam_penalties : this.match.localteam_penalties;
        }
        return +this.match.localteam_penalties + +this.match.visitorteam_penalties;
      }
      if (this.displayingStat === 'goals') {
        return this.match.localteam_goals;
      }
    },
    visitorTeamStat() {
      if (this.matchStatus === 'CANC') {
        return '-';
      }
      if (this.displayingStat === 'corners') {
        return this.match.visitorteam_corners;
      }
      if (this.displayingStat === 'cards') {
        if (this.currentFilters[1] === 'yellowcards') {
          return this.match.visitorteam_yellowcards;
        } else {
          return this.match.visitorteam_red_cards
        }
      }
      if (this.displayingStat === 'firsthalf') {
        return this.match.visitorteam_ht_goals;
      }
      if (this.displayingStat === 'secondhalf') {
        return +this.match.visitorteam_goals - +this.match.visitorteam_ht_goals  - +this.match.visitorteam_et_goals;
      }
      if (this.displayingStat === 'goals') {
        return this.match.visitorteam_goals;
      }
    },
    getResult() {
      if (this.penaltyShootoutOccurred) {
        return +this.match.localteam_penalty_shootout - +this.match.visitorteam_penalty_shootout;
      }
      return +this.localTeamStat - +this.visitorTeamStat;
    },
    matchStatus() {
      return this.match.status;
    },
  },
}
</script>